import { motion } from "framer-motion";

export default function Topbar() {
    return (
        <motion.header
            initial={{ y: -64, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="fixed inset-x-0 top-0 z-50 border-b border-[#222] bg-[#0d0d0d]/80 backdrop-blur-xl"
            data-testid="topbar"
        >
            <div className="mx-auto flex h-14 max-w-6xl items-center justify-between px-5">
                <a href="#" className="font-display text-sm font-extrabold tracking-tight sm:text-base" data-testid="brand-logo">
                    BIZECOM<span className="text-grad">ACADEMY</span>
                </a>
                <button
                    onClick={() => window.scrollToCalendar()}
                    className="btn-primary px-4 py-2 text-xs sm:text-sm"
                    data-testid="topbar-cta-button"
                >
                    Agendar consultoría
                </button>
            </div>
        </motion.header>
    );
}
